import { render, staticRenderFns } from "./submitScanning.vue?vue&type=template&id=e572ea02&scoped=true&"
import script from "./submitScanning.vue?vue&type=script&lang=js&"
export * from "./submitScanning.vue?vue&type=script&lang=js&"
import style0 from "./submitScanning.vue?vue&type=style&index=0&id=e572ea02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e572ea02",
  null
  
)

export default component.exports